module.exports = __webpack_public_path__ + "img/不良司男.3a7df44f.png";